export class UnterschriftDialogInput {
    titel: string = 'Unterschrift';
    unterschriftBase64: string;
    hinweisText: string;
    abbrechenText: string = 'Schließen';
}
